import { render } from "./SurveyResultPanel.vue?vue&type=template&id=383c975b&scoped=true"
import script from "./SurveyResultPanel.vue?vue&type=script&lang=js"
export * from "./SurveyResultPanel.vue?vue&type=script&lang=js"

import "./SurveyResultPanel.vue?vue&type=style&index=0&id=383c975b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c975b"]])

export default __exports__